<template>
  <div class='container'>

    <h1>Verified by GS1</h1>

    <div v-if='showBacklink' class='backlink'>
      <p>
        <a href='#' @click.prevent='$router.go(-1)'>
          <span class='fa fa-chevron-left'></span> {{ $t('back') }}
        </a>
      </p>
    </div>
    <template v-else>
      <search-form v-model='searchCopy' @error='setError' @submit='submit' style='margin-top: 40px'></search-form>
      <search-form-alerts v-if='error' :error='error' @suggest='applySuggestion'></search-form-alerts>
    </template>

    <gs1-alert-loading v-if='loading'></gs1-alert-loading>

    <template>
      <result-data v-if='gtinsVerifiedResponse' :gtinsVerifiedResponse='gtinsVerifiedResponse'
                   :glnsVerifiedResponse='glnsVerifiedResponse' :gs1Id='search' :mainLicensesVerifiedResponse='mainLicensesVerifiedResponse'></result-data>
      <gs1-alert-not-found v-else-if='notFound'></gs1-alert-not-found>
      <result-no-data v-else-if='companyName' :companyName='companyName'></result-no-data>
    </template>

  </div>
</template>

<script>
import { mapProduct } from '@/mixins/mapProduct'
import Gs1AlertLoading from '@/components/alerts/Gs1AlertLoading'
import Gs1AlertNotFound from '@/components/alerts/Gs1AlertNotFound'
import ResultData from '@/components/ResultData'
import ResultNoData from '@/components/ResultNoData'
import SearchForm from '@/components/SearchForm'
import SearchFormAlerts from '@/components/SearchFormAlerts'
import { saveGet } from '../../mixins/saveGet'

export default {
  name: 'Result',
  props: ['back', 'search'],
  components: {
    Gs1AlertLoading,
    Gs1AlertNotFound,
    ResultData,
    ResultNoData,
    SearchForm,
    SearchFormAlerts
  },
  mixins: [mapProduct, saveGet],
  data() {
    return {
      companyName: '',
      error: null,
      loading: false,
      notFound: false,
      product: null,
      gtinsVerifiedResponse: null,
      glnsVerifiedResponse: null,
      mainLicensesVerifiedResponse: null,
      searchCopy: this.search
    }
  },
  computed: {
    showBacklink() {
      return this.back && window.history.length > 1
    }
  },
  created() {
    this.load()
  },
  watch: {
    '$route': 'load'
  },
  methods: {
    applySuggestion(suggestion) {
      this.searchCopy = suggestion
      this.submit(this.searchCopy)
    },
    load() {
      this.reset()
      this.loading = true
      console.log(this.$verifiedAPI)
      this.$verifiedAPI.post('/verify_ids', [this.searchCopy.padStart(14, '0')])
        .then(response => {
          this.loading = false
          if (typeof response === 'undefined' || !Array.isArray(response.data) || !response.data.length > 0) {
            this.notFound = true
          }

          if (this.saveGet(response, '', 'data', 'gtins', 0, 'licenseeName')
            .includes('requested data privacy')) {
            this.companyName = this.saveGet(response, null, 'data', 'gtins', 0, 'licenseeName')
          } else {
            this.companyName = this.saveGet(response, null, 'data', 'glns', 0, 'gs1Licence', 'licenseeName')
          }

          this.gtinsVerifiedResponse = this.saveGet(response, null, 'data', 'gtins', 0)
          this.glnsVerifiedResponse = this.saveGet(response, null, 'data', 'glns')
          this.mainLicensesVerifiedResponse = this.saveGet(response, null, 'data', 'mainLicenses', 0)
        }, error => {
          this.loading = false
          if (error.response && error.response.status === 404) { // not found
            // try to retrieve company name
            this.notFound = true
          } else { // error
            const e = {
              key: 'UNKNOWN_ERROR',
              technicalDetails: error.response.data
            }
            if (error.response && error.response.status === 400) {
              if (error.response.data && error.response.data.code === 5) {
                const validationErrors = error.response.data.validationErrors.filter(v => v.property === 'gtin')
                if (typeof validationErrors !== 'undefined' && validationErrors.length > 0) {
                  const validationError = validationErrors[0]
                  if (validationError && validationError.property === 'gtin') {
                    const errors = validationError.errors
                    if (errors && errors.includes('E007')) {
                      e.key = 'GTIN_E007'
                    }
                  }
                }
              }
            }
            this.setError(e)
          }
        })
    },
    setError(error) {
      this.error = error
    },
    submit(search) {
      console.log('new search:', search, 'current search', this.search, 'current search route:', this.$route.params.search)
      if (search === this.$route.params.search) {
        this.load()
      } else {
        this.$router.push({ name: 'Result', params: { search } })
      }
    },
    reset() {
      console.log('reset')
      this.companyName = ''
      this.notFound = false
      this.product = null
      this.error = null
      this.loading = false
      this.notFound = false
      this.gtinsVerifiedResponse = null
      this.glnsVerifiedResponse = null
    }
  },
  i18n: {
    messages: {
      de: {
        invalid_check_digit: 'Die Prüfziffer der GTIN ist nicht korrekt, meinten Sie {0}?',
        registered_to: 'Diese GTIN ist unter der Firma {0} registriert.',
        back: 'Zurück zu den Suchergebnissen',
        companyStringCorrected: 'einer Firma welche den Datenschutz beantragt hat mit der GLN {0}'
      },
      en: {
        invalid_check_digit: 'Incorrect check digit. Did you mean {0}?',
        registered_to: 'This number is registered to {0}',
        back: 'Back to search results',
        companyStringCorrected: 'the company with the GLN {0} which registered data privacy'
      }
    }
  }
}
</script>

<style scoped>
.toolkit h1 {
  margin-bottom: 8px;
}

.toolkit form {
  margin-bottom: 30px;
}

.toolkit .backlink {
  margin-bottom: 45px;
}

.toolkit .backlink p {
  font-size: 17px;
  font-weight: normal;
  letter-spacing: -0.38px;
  line-height: 27px;
}

.toolkit .backlink p a {
  font-weight: normal;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/router/views/Result.vue